import styled from 'styled-components';
import { Container } from '@mui/material';

export const CustomContainer = styled(Container)``;
